import { ImageFilterName } from "@jackfruit/common"

export interface ImageFilter {
  name: ImageFilterName
  label: string
  matrix: string
}

export const IMAGE_FILTERS: ImageFilter[] = [
  {
    name: "original",
    label: "data.imageFilters.original",
    matrix: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0",
  },
  {
    name: "black_and_white",
    label: "data.imageFilters.black_and_white",
    matrix:
      "0.213 0.715 0.072 0 0  0.213 0.715 0.072 0 0  0.213 0.715 0.072 0 0  0 0 0 1 0",
  },
  {
    name: "high_contrast",
    label: "data.imageFilters.high_contrast",
    matrix: "1 1 1 0 -1 1 1 1 0 -1 1 1 1 0 -1 0 0 0 1 0",
  },
  {
    name: "sepia",
    label: "data.imageFilters.sepia",
    matrix:
      "0.393 0.769 0.189 0 0  0.349 0.686 0.168 0 0  0.272 0.534 0.131 0 0  0 0 0 1 0",
  },
  {
    name: "warm",
    label: "data.imageFilters.warm",
    matrix: "1.2 0.2 0.2 0.2 0  0.1 1.2 0.1 0.1 0  0 0 1.2 0 0  0 0 0 1 0",
  },
  {
    name: "cool",
    label: "data.imageFilters.cool",
    matrix: "1.2 0 0 0 0  0 1.2 0 0 0  0.1 0.1 1.2 0.1 0  0 0 0 1 0",
  },
  {
    name: "simple_warm",
    label: "data.imageFilters.simple_warm",
    matrix: "1 0.1 0.1 0.1 0  0.05 1 0.05 0.05 0  0 0 1 0 0  0 0 0 1 0",
  },
  {
    name: "simple_cool",
    label: "data.imageFilters.simple_cool",
    matrix: "1 0 0 0 0  0.05 1 0.05 0.05 0  0.1 0.1 1 0.1 0  0 0 0 1 0",
  },
  {
    name: "boost",
    label: "data.imageFilters.boost",
    matrix:
      "1.787 -0.715 -0.072 0 0  -0.213 1.285 -0.072 0 0  -0.213 -0.715 1.928 0 0  0 0 0 1 0",
  },
]

export function getImageFilter(name?: ImageFilterName) {
  if (!name) {
    return undefined
  }
  return IMAGE_FILTERS.find(f => f.name === name)
}
